import { getArrayByRanges } from "../../functions";

const DistanceService = async ({
  // loader,
  google,
  from, // [{ lat: 0, long: 0 }, { lat: 0, long: 0 },]
  to, // [{ lat: 0, long: 0 }, { lat: 0, long: 0 },]
  isAllResponse = false,
}) => {
  // const google = await loader.load();
  // const geocoder = new google.maps.Geocoder();
  const service = new google.maps.DistanceMatrixService(); // instantiate Distance Matrix service

  try {
    // console.log("from =>", from);
    // console.log("to =>", to);

    // to = to.slice(0, 25);
    const limit = 10;

    const rounds = Math.ceil(to.length / limit);
    // console.log("rounds =>", rounds);

    let response = {
      rows: [
        {
          elements: [],
        },
      ],
    };

    let countErrors = [];

    const arraySelected = getArrayByRanges({
      array: to,
      limit: 5,
    });

    // console.log("arraySelected =>", arraySelected);
    // let arrayCheck = [];
    // for (let i = 0 ; i < (arraySelected.length > 12  ? 12 :arraySelected.length )  ; i++) {
    //   // console.log(i);
    //   arrayCheck.push(arraySelected[i])
    // }
    // arrayCheck.push(arraySelected[0])
    // arrayCheck.push(arraySelected[0])
    // arrayCheck.push(arraySelected[0])
    // arrayCheck.push(arraySelected[0])
    // arrayCheck.push(arraySelected[0])
    // arrayCheck.push(arraySelected[0])
    // arrayCheck.push(arraySelected[0])
    // arrayCheck.push(arraySelected[0])
    // arrayCheck.push(arraySelected[0])
    // arrayCheck.push(arraySelected[0])
    // arrayCheck.push(arraySelected[0])
    // arrayCheck.push(arraySelected[0])
    // console.log('arrayCheck =>>', arrayCheck);
    // let index= 0
    for (const toSelected of arraySelected) {
      // console.log("toSelected =>", toSelected);
      // const start = i * limit;
      // const iEnd = i == 0 ? 1 : i + 1;
      // const end =
      //   i < rounds - 1
      //     ? iEnd * limit
      //     : to.length -
      //       Math.floor(to.length / limit) * limit +
      //       Math.floor(to.length / limit) * limit;

      // const toSelected = to.slice(start, end);

      // console.log(`index: ${i}, start =>`, start);
      // console.log(`index: ${i}, end =>`, end);
      // console.log(`index: ${i}, toSelected =>`, toSelected);

      const matrixOptions = {
        origins: from, // technician locations
        destinations: toSelected, // customer address
        // origins: [`${from.lat},${from.long}`], // technician locations
        // destinations: [
        //   `${to.lat},${to.long}`,
        //   "18.857657125173358, 99.10406554460495",
        // ], // customer address
        travelMode: "DRIVING",
        unitSystem: google.maps.UnitSystem.IMPERIAL,
      };
      // console.log(matrixOptions);
      // Call Distance Matrix service
      const res = await service.getDistanceMatrix(matrixOptions);

      // console.log("response distance service =>", res);

      if (res.rows[0].elements[0].status === "NOT_FOUND") {
        // console.log("get distance error!");
        alert("Get distance error!, please contact administrator!");
        break;
      } else {
        const array = res.rows[0].elements;
        // console.log("array check =>", response.rows[0].elements.concat(array));
        // console.log(response);
        response.rows[0].elements = response.rows[0].elements.concat(array);
      }
      // console.log("count =>>" ,index +1 );
      // index++
    }

    // console.log(countErrors);
    if (countErrors.length) {
      // console.log("Get some distance error =>: ", countErrors);
      return {
        error: {
          message: `Get some distance error`,
        },
      };
    }
    // console.log("response ready =>", response);

    return response;
  } catch (err) {
    if (err.code === "MAX_DIMENSIONS_EXCEEDED") {
      alert("Error: " + err.message);
      // console.log("error MAX_DIMENSIONS_EXCEEDED !!!!!!!!");

      // "distance failed due to: DISTANCE_MATRIX: OVER_QUERY_LIMIT: Too many elements have been requested within the allowed time period. The request should succeed if you try again after some time."
    } else {
      // console.log(err.message);
      return {
        error: {
          message: `distance failed due to: ${err.message}`,
        },
      };
    }
  }
};

export default DistanceService;
